<template>
  <div class="card cs-filters-card" :class="{ 'cs-filters-active': hasActiveFilters }">
    <div class="card-header border-0 bg-transparent pt-3 pb-0 px-4">
      <div class="d-flex align-items-center">
        <div class="filter-icon-wrapper me-2">
          <i class="fas fa-filter text-primary"></i>
        </div>
        <h6 class="mb-0 fw-bold text-dark opacity-75" style="font-size: 0.75rem; text-transform: uppercase; letter-spacing: 1px;">
          Filtros de Busca
        </h6>
      </div>
    </div>
    <div class="card-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-2">
          <label class="filter-label">Início</label>
          <date-picker v-model="filters.startDate" format="DD/MM/YYYY" value-type="format" placeholder="Início" />
        </div>
        <div class="col-md-2">
          <label class="filter-label">Fim</label>
          <date-picker v-model="filters.endDate" format="DD/MM/YYYY" value-type="format" placeholder="Fim" />
        </div>
        <div class="col-md-2">
          <label class="filter-label">Consultor</label>
          <v-select :reduce="i => i.id" placeholder="Selecione..." label="name" v-model="filters.user" :options="users" append-to-body />
        </div>
        <div class="col-md-2">
          <label class="filter-label">Cliente</label>
          <v-select :reduce="i => i.id" placeholder="Selecione..." label="name" v-model="filters.customer" :options="customers" append-to-body />
        </div>
        <div class="col-md-2">
          <label class="filter-label">Atividade</label>
          <v-select :reduce="i => i.id" placeholder="Selecione..." label="name" v-model="filters.task" :options="tasks" append-to-body />
        </div>
        <div class="col-md-2">
          <label class="filter-label">Classificação</label>
          <v-select :reduce="i => i.id" placeholder="Selecione..." label="name" v-model="filters.taskType" :options="taskTypes" append-to-body />
        </div>
        
        <div class="col-md-2">
          <label class="filter-label">Status</label>
          <v-select :reduce="i => i.id" placeholder="Todos" label="name" v-model="filters.status" :options="servicesStatus" append-to-body />
        </div>
        <div class="col-md-8">
          <label class="filter-label">Observação</label>
          <input class="form-control form-control-sm" type="text" v-model="filters.note" placeholder="Buscar texto na observação..." />
        </div>
        <div class="col-md-2 d-flex gap-2 justify-content-end">
          <button class="btn btn-sm btn-warning" @click="search" title="Filtrar">
            <i class="fa fa-search"></i>
          </button>
          <button class="btn btn-sm btn-danger" @click="clear" title="Limpar Filtros">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'TicketFilters',
  components: { vSelect, DatePicker },
  props: {
    users: Array,
    customers: Array,
    tasks: Array,
    taskTypes: Array,
    servicesStatus: Array
  },
  data() {
    return {
      filters: {
        startDate: '',
        endDate: '',
        user: null,
        customer: null,
        task: null,
        taskType: null,
        status: null,
        note: ''
      }
    }
  },
  computed: {
    hasActiveFilters() {
      return !!(this.filters.startDate || this.filters.endDate || this.filters.user || 
                this.filters.customer || this.filters.task || this.filters.taskType || 
                this.filters.status || this.filters.note)
    }
  },
  methods: {
    search() {
      this.$emit('filter', { ...this.filters })
    },
    clear() {
      this.filters = {
        startDate: '',
        endDate: '',
        user: null,
        customer: null,
        task: null,
        taskType: null,
        status: null,
        note: ''
      }
      this.$emit('clear')
    }
  }
}
</script>

<style scoped lang="sass">
.cs-filters-card
  border: none
  border-radius: 16px
  background: rgba(255, 255, 255, 0.8)
  backdrop-filter: blur(10px)
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05)
  margin-bottom: 2rem
  transition: all 0.3s ease
  position: relative

  &.cs-filters-active
    box-shadow: 0 10px 30px rgba(255, 193, 7, 0.15)
    border: 1px solid rgba(255, 193, 7, 0.2)

.card-body
  padding: 1.25rem 1.5rem

.filter-icon-wrapper
  width: 24px
  height: 24px
  background: rgba(0, 168, 255, 0.1)
  border-radius: 6px
  display: flex
  align-items: center
  justify-content: center
  i
    font-size: 0.7rem

.filter-label
  display: block
  font-size: 0.65rem
  font-weight: 800
  color: #a4b0be
  text-transform: uppercase
  letter-spacing: 1px
  margin-bottom: 8px
  margin-left: 2px

.v-select
  --vs-border-color: #dfe6e9
  --vs-border-radius: 10px
  --vs-font-size: 0.85rem
  --vs-line-height: 1.2
  background: white
  height: 38px // Altura fixa para alinhar com inputs

  ::v-deep .vs__dropdown-toggle
    border-width: 2px
    height: 38px
    padding: 0 8px
    display: flex
    align-items: center

  ::v-deep .vs__selected
    margin: 0
    padding: 0
    line-height: 1.2

  ::v-deep .vs__actions
    padding: 2px 0 0 0

  ::v-deep .vs__search
    margin: 0
    padding: 0

.form-control-sm
  border: 2px solid #dfe6e9
  border-radius: 10px
  padding: 8px 12px
  font-size: 0.85rem
  height: 38px
  background: white
  
  &:focus
    border-color: #00a8ff
    box-shadow: 0 0 0 3px rgba(0, 168, 255, 0.1)

.mx-datepicker
  width: 100% !important
  height: 38px
  
  ::v-deep .mx-input
    border: 2px solid #dfe6e9
    border-radius: 10px
    height: 38px
    box-shadow: none
    font-size: 0.85rem
    background: white

.btn-sm
  height: 38px
  width: 38px
  border-radius: 10px
  display: flex
  align-items: center
  justify-content: center
  border: none
  transition: all 0.2s ease

  &.btn-warning
    background: #ffa502
    color: white
    &:hover
      background: #ff7f50
      transform: scale(1.05)

  &.btn-danger
    background: #ff4757
    color: white
    &:hover
      background: #ff6b81
      transform: scale(1.05)
</style>
